import BaseObject from 'entities/base_object'
import moment from 'moment'
import Image from './image'

export default class Article extends BaseObject {
  constructor(object) {
    super(object)

    this.id = object.id || null
    this.token = object.token || null
    this.status = object.status || null
    this.priority = object.priority
    this.priorityChangeable = object.priority_changeable
    this.cover = object.cover ? new Image(object.cover) : null
    this.coverCache = object.cover_cache || null
    this.title = object.title || null
    this.body = object.body || null
    this.summary = object.summary || null
    this.pageViewsCount = object.page_views_count || 0
    this.publishedAt = moment.unix(object.published_at)
    this.updatedAt = moment.unix(object.updated_at)
    this.url = object.url || null
    this.sequentialId = parseInt(object.sequential_id, 10) || null
  }

  isPublished() {
    return this.status === 'published'
  }

  isDraft() {
    return this.status === 'draft'
  }

  isPersisted() {
    return this.id !== null
  }
}
